import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeWarehouseCreate,
  detail: routeWarehouseDetail,
  home: routeWarehousesHome,
  root: routeWarehousesRoot,
} = createDoctypeRoutes({
  createName: 'new-warehouse',
  createPath: 'new-warehouse',
  detailName: 'warehouse-detail',
  doctype: DOCTYPES.WAREHOUSE,
  homeName: 'warehouses-home',
  ifOwner: false,
  path: 'warehouses',
  views: {
    create: async () => await import('@/components/viewsExternal/warehouse/AddWarehouse.vue'),
    detail: async () => await import('@/components/viewsExternal/warehouse/ViewWarehouse.vue'),
    list: async () => await import('@/components/viewsExternal/warehouse/WarehouseView.vue'),
  },
})

export { routeWarehouseCreate, routeWarehouseDetail, routeWarehousesHome, routeWarehousesRoot }
